import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum NotificationType {
    SUCCESS,
    WARNING,
    ERROR
}

export interface NotificationItem {
    message: string;
    type: NotificationType
}

export interface NotificationsState {
    notifications: NotificationItem[];
}

const initialState: NotificationsState = {
    notifications: []
}

export const notificationsSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        addNotification: (state, action: PayloadAction<NotificationItem>) => {
            state.notifications.push(action.payload);
        },
        popNotification: (state, action: PayloadAction<number>) => {
            state.notifications.pop();
        }
    }
})

export const {addNotification, popNotification} = notificationsSlice.actions;

export default notificationsSlice.reducer;